import { Role } from '../../models/UserModels';
export const isInRole = (currentRoles: Role[], requiredRoles: Role[]) => {
  return !!currentRoles.find((userRole) => {
    return requiredRoles.includes(userRole);
  });
};
